<script setup lang="ts">
	const { type = 'default' } = defineProps<{
		type?: 'default'|'large'
	}>()

	const cacheKey = 'current-run'
	const run = ref({})
	const cachedData = useNuxtData(cacheKey)
	if (cachedData.data.value) {
		run.value = cachedData.data.value
	}
</script>

<template>
	<template v-if="run?.registration?.link">
		<LayoutBtnDavengoLarge v-if="type =='large'" :link="run.registration.link"></LayoutBtnDavengoLarge>
		<LayoutBtnDavengo v-else :link="run.registration.link"></LayoutBtnDavengo>
	</template>
</template>
